export default __webpack_public_path__ + "static/media/Shoes2.ba71ddc4.png";